export default function Clients() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-cyan-600 font-semibold mb-2 tracking-wider text-sm">CLIENTS</p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">함께하는 고객사</h2>
          <p className="text-gray-600 text-lg">고객사가 신뢰하는 물류 파트너</p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <img 
              src="https://static.readdy.ai/image/2de9e8192ae00a75b7d7b36ef2548e1c/1180dd89ba31bfcd638586aa72aee6ab.png" 
              alt="고객사 로고" 
              className="w-full h-auto object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}